import { render } from "./Chapters.vue?vue&type=template&id=7d11706e"
import script from "./Chapters.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/chapter/Chapters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d11706e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d11706e', __exports__)) {
    api.reload('7d11706e', __exports__)
  }
  
  module.hot.accept("./Chapters.vue?vue&type=template&id=7d11706e", () => {
    api.rerender('7d11706e', render)
  })

}


export default __exports__